<template>
  <v-app>
    <Header ref="header"/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout wrap>
          <v-flex text-xs-left xs12 md6 px-3 v-if="!currentShipment">
            <v-text-field v-model="search" append-icon="search" placeholder="Search" v-if="!currentShipment" style="padding-bottom: 0 !important; display: inline-flex; width: 350px; margin-right: 25px;"></v-text-field>
            <div style="display: inline-block;">
              <v-btn flat @click="previousPage" class="bw-3" v-if="lastPage > 1 && isShowingDeliveredShipments" :disabled="currentPage === 1">Page {{ currentPage > 1 ? currentPage-1 : currentPage }}</v-btn>
              <v-btn flat @click="nextPage" class="bw-3" v-if="lastPage > 1 && isShowingDeliveredShipments" :disabled="currentPage === lastPage" style="margin-right: 30px;">Page {{ currentPage+1 }}</v-btn>
            </div>
          </v-flex>
          <v-flex text-xs-right xs12 md6 v-if="!currentShipment">
            <v-btn flat @click="toggleFilterDelivered(false)" class="bw-4" :style="buttonStyleFilterProduction" :disabled="!filterDelivered">Production</v-btn>
            <v-btn flat @click="toggleFilterDelivered(true)" class="bw-4" :style="buttonStyleFilterDelivered" :disabled="filterDelivered" style="margin-right: 50px;">Delivered</v-btn>
            <v-btn flat @click="print" class="bw-3">Print</v-btn>
            <v-btn flat @click="editNewShipment" class="bw-7">Create new shipment</v-btn>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="!currentShipment">
            <v-select :items="filterCustomers" v-model="filterCustomer" item-text="name" prepend-icon="a-store" return-object @change="loadShipments()" class="customerFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 v-if="!currentShipment" style="padding-top: 6px;">
            <v-select :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object @change="loadShipments()" class="supplierFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md4 px-3 v-if="!currentShipment" style="padding-top: 6px;">
            <v-autocomplete :items="filterCategories" v-model="filterCategory" item-text="displayLabel" prepend-icon="a-trees" return-object @change="loadShipments()" class="categoryFilter">
              <template slot="selection" slot-scope="data">
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
              <template slot="item" slot-scope="data">
                <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                {{ data.item.displayLabel }}
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex text-xs-right xs12 v-if="currentShipment">
            <v-btn flat @click="startViewLog" class="bw-3" style="float: left;" v-if="canViewLog && !approvalStarted && !sendStarted && !viewLog">Log</v-btn>
            <v-btn flat v-if="canCompleteLoading && !approvalStarted && !viewLog" @click="startLoadingComplete" class="bw-6" style="float: left;">Loading complete</v-btn>
            <v-btn flat v-if="canApprove && !approvalStarted && !viewLog" @click="startApprove" class="bw-4" style="float: left;">Approve</v-btn>
            <v-btn flat v-if="canSend && !sendStarted && !viewLog" @click="startSend" class="bw-6" style="float: left;">{{ currentShipment.deliveryNoteSentDate ? 'Resend delivery note' : 'Send delivery note' }}</v-btn>
            <v-btn flat v-if="canCreateInvoice && !viewLog" @click="createInvoice" :class="currentShipment.draftInvoiceNumber ? 'bw-7' : 'bw-5'" style="float: left;" :disabled="creatingInvoice">{{ currentShipment.draftInvoiceNumber ? 'Create a new invoice' : 'Create invoice' }}</v-btn>
            <v-progress-circular indeterminate color="primary" v-if="creatingInvoice" size="24" width="3" style="float: left; margin-left: 20px; margin-top: 5px;"/>
            <v-btn flat v-if="(!lockedForEdit || canUpdate) && !approvalStarted && !sendStarted && !viewLog && !isInternalTransportShipment" :disabled="!saveButtonEnabled" @click="save" class="bw-3">{{ currentShipment.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="canDelete && !approvalStarted && !sendStarted && !viewLog" @click="confirmDeleteDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="!lockedForEdit && !approvalStarted && !sendStarted && !viewLog" :disabled="!canAddDelivery" @click="addDelivery" class="bw-4">Add delivery</v-btn>
            <v-btn flat v-if="canPrintDeliveryNote && !viewLog" @click="openPrintDeliveryNoteDialog" class="bw-4">Delivery note</v-btn>
            <v-btn flat v-if="!approvalStarted && !sendStarted && !viewLog" @click="cancel" class="bw-3">{{ lockedForEdit ? 'Close' : 'Cancel'}}</v-btn>
            <v-btn flat v-if="approvalStarted" @click="cancelApprove" class="bw-3">Cancel</v-btn>
            <v-btn flat v-if="sendStarted" @click="cancelSend" class="bw-3">Cancel</v-btn>
            <v-btn flat @click="endViewLog" class="bw-3" v-if="viewLog">Close</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="!currentShipment" >
        <v-layout style="max-height: calc(100vh - 200px);">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="tableHeaders" :items="pagedShipments" ref="shipments" hide-actions :disable-initial-sort="sortTable" class="shipmentTable" no-data-text="No shipments found">
              <template v-slot:items="props">
                <tr @click="selectShipment(props.item)" :class="rowColor(props.item)">
                  <td class="text-xs-left shipmentNo singleLine">{{ props.item.number }}</td>
                  <td class="text-xs-left nowrap singleLine">{{ stateLabel(props.item.state) }}</td>
                  <td class="text-xs-left singleLine">{{ props.item.customerName }}</td>
                  <td class="text-xs-left nowrap"><div v-html="props.item.pickupAddresses"></div></td>
                  <td class="text-xs-left nowrap"><div v-html="props.item.suppliers"></div></td>
                  <td class="text-xs-left nowrap"><div v-html="props.item.fields"></div></td>
                  <td class="text-xs-left nowrap" style="padding-bottom: 1px !important;"><div v-html="props.item.categories"></div></td>
                  <td class="text-xs-left nowrap"><div v-html="props.item.amounts"></div></td>
                  <td class="text-xs-left singleLine">{{ props.item.pickupDate }}</td>
                  <td class="text-xs-left singleLine">{{ props.item.deliveryDate }}</td>
                  <td class="text-xs-left singleLine">{{ props.item.carrierName }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentShipment && approvalStarted">
        <v-layout>
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Approve shipment">
                <v-flex xs12 class="approveWithMissingCategories" v-if="hasMissingCategories">
                  The shipment has one or more pallets without categories
                </v-flex>
                <v-flex xs12 class="approveWithPotentialIncorrectDates" v-if="hasPotentialIncorrectDates">
                  Check that the loading and delivery dates are correct
                </v-flex>

                <v-flex xs12 sm3 lg2 style="height: 35px;">
                  <v-label>Loading date</v-label>
                </v-flex>
                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <table>
                    <tr>
                      <td>
                        <v-menu v-model="pickupDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="pickupDate" prepend-icon="event" readonly style="width: 120px;" v-on="on" :disabled="lockedForUpdate"></v-text-field>
                          </template>
                          <v-date-picker v-model="pickupDate" @input="pickupDateMenu = false"></v-date-picker>
                        </v-menu>
                      </td>
                      <td style="padding-left: 25px;">
                        <v-menu v-model="pickupTimeMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="pickupTime" prepend-icon="access_time" readonly style="width: 85px" v-on="on" :disabled="lockedForUpdate"></v-text-field>
                          </template>
                          <v-time-picker v-if="pickupTimeMenu" v-model="pickupTime" :allowed-minutes="pickupAllowedSteps" class="mt-3" format="24hr" @click:minute="pickupTimeMenu = false"></v-time-picker>
                        </v-menu>
                      </td>
                    </tr>
                  </table>
                </v-flex>
                <v-flex xs12 sm5 lg8 style="height: 10px;">&nbsp;</v-flex>

                <v-flex xs12 sm3 lg2 style="height: 35px;">
                  <v-label>Delivery date</v-label>
                </v-flex>
                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <table>
                    <tr>
                      <td>
                        <v-menu v-model="deliveryDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="deliveryDate" prepend-icon="event" readonly style="width: 120px;" v-on="on" :disabled="lockedForUpdate"></v-text-field>
                          </template>
                          <v-date-picker v-model="deliveryDate" @input="deliveryDateMenu = false"></v-date-picker>
                        </v-menu>
                      </td>
                      <td style="padding-left: 25px;">
                        <v-menu v-model="deliveryTimeMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="deliveryTime" prepend-icon="access_time" readonly style="width: 85px" v-on="on" :disabled="lockedForUpdate"></v-text-field>
                          </template>
                          <v-time-picker v-if="deliveryTimeMenu" v-model="deliveryTime" :allowed-minutes="deliveryAllowedSteps" class="mt-3" format="24hr" @click:minute="deliveryTimeMenu = false"></v-time-picker>
                        </v-menu>
                      </td>
                    </tr>
                  </table>
                </v-flex>
                <v-flex xs12 sm5 lg8 style="height: 10px;">&nbsp;</v-flex>

                <v-flex xs12 sm3 lg2 style="height: 35px;">
                  <v-label>E-mail</v-label>
                </v-flex>
                <v-flex xs12 sm9 lg10 style="height: 35px;">
                  <v-text-field color="teal" v-model="approvalEmail" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 lg2 style="height: 35px;">
                  <v-label>Subject</v-label>
                </v-flex>
                <v-flex xs12 sm9 lg10 style="height: 35px;">
                  <v-text-field color="teal" v-model="approvalSubject" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-label>Message</v-label>
                </v-flex>
                <v-flex xs12>
                  <wysiwyg v-model="approvalMessage" class="approve-shipment"></wysiwyg>
                </v-flex>
                <v-flex xs12 style="padding-top: 10px;">
                  <v-btn flat @click="approveAndSend" :disabled="!approvalEmailCorrect" class="bw-6" style="float: right;">Approve and send</v-btn>
                  <v-btn flat @click="approveOnly" class="bw-4" style="float: right;">Approve</v-btn>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentShipment && sendStarted">
        <v-layout>
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Send shipment">
                <v-flex xs12 sm3 lg2 style="height: 35px;">
                  <v-label>E-mail</v-label>
                </v-flex>
                <v-flex xs12 sm9 lg10 style="height: 35px;">
                  <v-text-field color="teal" v-model="sendEmail" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 lg2 style="height: 35px;">
                  <v-label>Subject</v-label>
                </v-flex>
                <v-flex xs12 sm9 lg10 style="height: 35px;">
                  <v-text-field color="teal" v-model="sendSubject" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-label>Message</v-label>
                </v-flex>
                <v-flex xs12>
                  <wysiwyg v-model="sendMessage" class="approve-shipment"></wysiwyg>
                </v-flex>
                <v-flex xs12 style="padding-top: 10px;">
                  <v-btn flat @click="send" :disabled="!sendEmailCorrect" class="bw-3" style="float: right;">Send</v-btn>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentShipment && !approvalStarted && !sendStarted && !viewLog">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Shipment" :title-right="stateLabel(currentShipment.state)">
                <v-flex xs12 sm3 lg2 style="height: 35px;">
                  <v-label>Shipment no.</v-label>
                </v-flex>
                <v-flex xs12 sm3 lg3 style="height: 35px;">
                  <v-text-field color="teal" v-model="currentShipment.number" ref="number" autocomplete="offit" :disabled="isInternalTransportShipment"/>
                </v-flex>
                <v-flex xs0 sm1 lg4 style="height: 10px;">&nbsp;</v-flex>
                <v-flex xs12 sm5 lg3 style="height: 35px; padding-top: 3px;" px-5 text-xs-right>
                  <div v-if="!isInternalTransportShipment">
                    <v-label>Number of pallets</v-label>
                    &nbsp;&nbsp;&nbsp;
                    {{ totalNumberOfPallets() }}
                  </div>
                  <div v-if="isInternalTransportShipment && currentShipment.createdByName !== ''">
                    <span>Created by {{ currentShipment.createdByName }}</span>
                  </div>
                </v-flex>

                <v-flex xs12 sm3 lg2 v-if="!isInternalTransportShipment" style="height: 35px;">
                  <v-label>Customer</v-label>
                </v-flex>
                <v-flex xs12 sm9 lg10 v-if="!isInternalTransportShipment" style="height: 35px;">
                  <v-select :items="customers" v-model="currentShipment.customer" item-text="name" return-object @change="changeCustomer" :disabled="lockedForUpdate"/>
                </v-flex>

                <v-flex xs12 sm3 lg2 v-if="!isInternalTransportShipment" style="height: 35px;">
                  <v-label>Carrier</v-label>
                </v-flex>
                <v-flex xs12 sm9 lg10 v-if="!isInternalTransportShipment" style="height: 35px;">
                  <v-select :items="carriers" v-model="currentShipment.carrier" item-text="name" return-object :disabled="lockedForUpdate"/>
                </v-flex>

                <v-flex xs12 sm3 lg2 v-if="!isInternalTransportShipment" style="height: 35px;">
                  <v-label>Fixed pallet positions</v-label>
                </v-flex>
                <v-flex xs12 sm9 lg10 v-if="!isInternalTransportShipment" style="height: 35px;">
                  <v-checkbox v-model="currentShipment.fixedPalletPositions" color="teal" :disabled="lockedForUpdate"/>
                </v-flex>

                <v-flex xs12 sm3 lg2 v-if="!isInternalTransportShipment" style="height: 35px;">
                  <v-label>Loading date</v-label>
                </v-flex>
                <v-flex xs12 sm4 lg2 v-if="!isInternalTransportShipment" style="height: 35px;">
                  <table>
                    <tr>
                      <td>
                        <v-menu v-model="pickupDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="pickupDate" prepend-icon="event" readonly style="width: 120px;" v-on="on" :disabled="lockedForUpdate"></v-text-field>
                          </template>
                          <v-date-picker v-model="pickupDate" @input="pickupDateMenu = false"></v-date-picker>
                        </v-menu>
                      </td>
                      <td style="padding-left: 25px;">
                        <v-menu v-model="pickupTimeMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="pickupTime" prepend-icon="access_time" readonly style="width: 85px" v-on="on" :disabled="lockedForUpdate"></v-text-field>
                          </template>
                          <v-time-picker v-if="pickupTimeMenu" v-model="pickupTime" :allowed-minutes="pickupAllowedSteps" class="mt-3" format="24hr" @click:minute="pickupTimeMenu = false"></v-time-picker>
                        </v-menu>
                      </td>
                    </tr>
                  </table>
                </v-flex>
                <v-flex xs12 sm5 lg8 v-if="!isInternalTransportShipment" style="height: 10px;">&nbsp;</v-flex>

                <v-flex xs12 sm3 lg2 v-if="!isInternalTransportShipment" style="height: 35px;">
                  <v-label>Delivery date</v-label>
                </v-flex>
                <v-flex xs12 sm4 lg2 v-if="!isInternalTransportShipment" style="height: 35px;">
                  <table>
                    <tr>
                      <td>
                        <v-menu v-model="deliveryDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="deliveryDate" prepend-icon="event" readonly style="width: 120px;" v-on="on" :disabled="lockedForUpdate"></v-text-field>
                          </template>
                          <v-date-picker v-model="deliveryDate" @input="deliveryDateMenu = false"></v-date-picker>
                        </v-menu>
                      </td>
                      <td style="padding-left: 25px;">
                        <v-menu v-model="deliveryTimeMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="deliveryTime" prepend-icon="access_time" readonly style="width: 85px" v-on="on" :disabled="lockedForUpdate"></v-text-field>
                          </template>
                          <v-time-picker v-if="deliveryTimeMenu" v-model="deliveryTime" :allowed-minutes="deliveryAllowedSteps" class="mt-3" format="24hr" @click:minute="deliveryTimeMenu = false"></v-time-picker>
                        </v-menu>
                      </td>
                    </tr>
                  </table>
                </v-flex>
                <v-flex xs12 sm5 lg8 v-if="!isInternalTransportShipment" style="height: 10px;">&nbsp;</v-flex>

                <v-flex xs12 sm3 lg2 style="height: 35px;">
                  <v-label>License plate(s)</v-label>
                </v-flex>
                <v-flex xs12 sm9 lg6 style="height: 35px;">
                  <v-text-field color="teal" v-model="currentShipment.licensePlate" autocomplete="offit" :disabled="lockedForUpdate || isInternalTransportShipment"></v-text-field>
                </v-flex>

                <v-flex xs12 v-if="!isInternalTransportShipment">
                  <v-label>Comments</v-label>
                </v-flex>
                <v-flex xs12 v-if="!isInternalTransportShipment">
                  <v-textarea solo auto-grow flat rows="3" v-model="currentShipment.comment" :disabled="lockedForUpdate"></v-textarea>
                </v-flex>

                <v-flex xs12 v-if="hasMultipleDeliveryAddresses" style="margin-top: 10px;">
                  <v-label>Order of deliveries</v-label>
                </v-flex>
                <v-flex xs12 v-if="hasMultipleDeliveryAddresses">
                  <Draggable :list="currentShipment.deliveryAddressOrders" class="draggable" ghost-class="draggable-ghost" @end="updateDeliveryAddressOrders">
                    <div v-for="deliveryAddressOrder in currentShipment.deliveryAddressOrders" :key="'deliveryAddress_' + deliveryAddressOrder.deliveryAddress.id" class="draggable-item deliveryAddressOrder">
                      <div>{{ deliveryAddressOrder.deliveryAddress.address.nameAndText }}</div>
                    </div>
                  </Draggable>
                </v-flex>

                <v-flex xs12 v-if="hasPalletOrders" style="padding-top: 20px;">
                  <v-label>Planned pallets</v-label>
                </v-flex>
                <v-flex xs12 v-if="hasPalletOrders">
                  <table class="palletPosition" width="100%">
                    <tr>
                      <ShipmentPalletOrder number="1" :positions="palletOrderPositions"/>
                      <ShipmentPalletOrder number="3" :positions="palletOrderPositions"/>
                      <ShipmentPalletOrder number="5" :positions="palletOrderPositions"/>
                      <ShipmentPalletOrder number="7" :positions="palletOrderPositions"/>
                      <ShipmentPalletOrder number="9" :positions="palletOrderPositions"/>
                    </tr>
                    <tr>
                      <ShipmentPalletOrder number="2" :positions="palletOrderPositions"/>
                      <ShipmentPalletOrder number="4" :positions="palletOrderPositions"/>
                      <ShipmentPalletOrder number="6" :positions="palletOrderPositions"/>
                      <ShipmentPalletOrder number="8" :positions="palletOrderPositions"/>
                      <ShipmentPalletOrder number="10" :positions="palletOrderPositions"/>
                    </tr>
                  </table>
                </v-flex>

                <v-flex xs12 style="padding-top: 20px;" v-if="(hasPalletOrders || isInternalTransportShipment) && hasPallets">
                  <v-label>Pallets</v-label>
                </v-flex>
                <v-flex xs12 v-if="(hasPalletOrders || isInternalTransportShipment) && hasPallets">
                  <table class="palletPosition" width="100%">
                    <tr>
                      <ShipmentPallet number="1" :palletPositions="palletPositions" :half="isHalfPalletPosition(1)" @change="palletSelected" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="3" :palletPositions="palletPositions" :half="isHalfPalletPosition(3)" @change="palletSelected" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="5" :palletPositions="palletPositions" :half="isHalfPalletPosition(5)" @change="palletSelected" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="7" :palletPositions="palletPositions" :half="isHalfPalletPosition(7)" @change="palletSelected" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="9" :palletPositions="palletPositions" :half="isHalfPalletPosition(9)" @change="palletSelected" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                    </tr>
                    <tr>
                      <ShipmentPallet number="2" :palletPositions="palletPositions" :half="isHalfPalletPosition(2)" @change="palletSelected" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="4" :palletPositions="palletPositions" :half="isHalfPalletPosition(4)" @change="palletSelected" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="6" :palletPositions="palletPositions" :half="isHalfPalletPosition(6)" @change="palletSelected" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="8" :palletPositions="palletPositions" :half="isHalfPalletPosition(8)" @change="palletSelected" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="10" :palletPositions="palletPositions" :half="isHalfPalletPosition(10)" @change="palletSelected" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                    </tr>
                  </table>
                </v-flex>

                <v-flex xs12 style="padding-top: 20px;" v-if="hasLooseGoods">
                  <v-label>Loose goods</v-label>
                </v-flex>
                <v-flex xs12 v-if="hasLooseGoods">
                  <table class="palletPosition looseGoods" width="30%">
                    <tr v-for="looseGoodsPallet in looseGoodsPallets" :key="'looseGoods_' + looseGoodsPallet.id">
                      <ShipmentLooseGoods :pallet="looseGoodsPallet" @change="palletSelected" :pallet-selected="currentPallet"/>
                    </tr>
                  </table>
                </v-flex>

                <v-flex xs12 v-if="currentShipment && currentShipment.id && !currentPallet && !currentPalletPosition && !action && !isInternalTransportShipment" class="actions">
                  <div class="actionTitle">Actions</div>
                  <v-btn flat @click="prepareLoadLooseGoods" class="bw-6">Load loose goods</v-btn>
                  <v-btn flat @click="prepareCreateLooseGoods" class="bw-6">Create loose goods</v-btn>
                </v-flex>
                <v-flex xs12 v-if="currentPallet || currentPalletPosition || action === 'LOAD_LOOSE_GOODS' || action === 'CREATE_LOOSE_GOODS'" class="actions">
                  <div class="actionTitle" v-if="currentPallet || currentPalletPosition">Actions for {{ currentPalletPosition && currentPalletPosition > 10 ? 'secondary ' : '' }}pallet {{ currentPallet ? '#' + currentPallet.palletNumber : 'on position ' + (currentPalletPosition > 10 ? currentPalletPosition - 10 : currentPalletPosition) }}</div>
                  <div class="actionTitle" v-if="!(currentPallet || currentPalletPosition)">Actions</div>
                  <v-btn flat @click="prepareLoadPallet" class="bw-6" v-if="currentPalletPosition && !action">Load pallet</v-btn>
                  <v-btn flat @click="prepareUnload" class="bw-6" v-if="currentPallet && currentPallet.state === 'DELIVERED' && !action">Unload</v-btn>
                  <v-btn flat @click="prepareDeliveryComment" class="bw-6" v-if="currentPallet && currentPallet.state === 'DELIVERED' && currentPallet.position > 0 && !action">Delivery comment</v-btn>
                  <v-btn flat @click="prepareCreatePallet" class="bw-6" v-if="currentPalletPosition && !action">Create new pallet</v-btn>
                  <v-btn flat @click="cancelPalletAction" class="bw-3" style="float: right;">Cancel</v-btn>
                  <div v-if="(action === 'LOAD' || action === 'LOAD_LOOSE_GOODS') && !this.palletsByNumber" style="padding: 25px 3px 2px 3px;">
                    <table>
                      <tr>
                        <td style="padding: 10px 25px 10px 10px;"><v-label>Pallet number</v-label></td>
                        <td>
                          <v-text-field v-model="loadPalletNumber" style="width: 125px;"/>
                        </td>
                      </tr>
                    </table>
                    <v-btn flat @click="tryLoadPallet" class="bw-3">Load</v-btn>
                  </div>
                  <div v-if="(action === 'LOAD' || action === 'LOAD_LOOSE_GOODS') && this.palletsByNumber && this.palletsByNumber.length > 1" style="padding: 50px 3px 2px 3px;">
                    <v-radio-group v-model="chosenPallet">
                      <table class="choosePallet">
                        <tr>
                          <th></th>
                          <th class="text-xs-left" style="width: 100px;">Pallet no.</th>
                          <th class="text-xs-left" style="width: 140px;">Ext. pallet no.</th>
                          <th class="text-xs-left" style="width: 120px;">State</th>
                          <th class="text-xs-left">Category</th>
                          <th class="text-xs-right" style="width: 110px;">Amount</th>
                        </tr>
                        <tr v-for="pallet in this.palletsByNumber" v-bind:key="pallet.id">
                          <td>
                            <v-radio :value="pallet" color="#004d40"></v-radio>
                          </td>
                          <td class="text-xs-left">{{ pallet.number }}</td>
                          <td class="text-xs-left">{{ pallet.externalNumber }}</td>
                          <td class="text-xs-left">{{ pallet.stateLabel }}</td>
                          <td class="text-xs-left"><div v-html="pallet.categories"></div></td>
                          <td class="text-xs-right" style="width: 60px;"><div v-html="pallet.amounts"></div></td>
                        </tr>
                      </table>
                    </v-radio-group>
                    <v-btn flat @click="loadChosenPallet" class="bw-3" :disabled="!chosenPallet">Load</v-btn>
                  </div>
                  <div v-if="action === 'UNLOAD'" style="padding: 5px 3px 2px 3px;">
                    <table style="width: 100%;">
                      <tr>
                        <td style="padding: 10px;"><v-label>Stock location</v-label></td>
                        <td>
                          <v-select :items="pickupAddresses" v-model="stockAddress" item-text="text" return-object></v-select>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <v-btn flat @click="unload" class="bw-3" v-if="action === 'UNLOAD'">Unload</v-btn>
                  <div v-if="action === 'DELIVERY_COMMENT'" style="padding: 5px 3px 2px 3px;">
                    <table>
                      <tr>
                        <td style="padding-top: 8px; padding-left: 10px; width: 160px; vertical-align: top;"><v-label>Delivery comment</v-label></td>
                        <td style="width: 400px;">
                          <v-textarea solo auto-grow flat v-model="deliveryComment" rows="3" maxlength="255"/>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <v-btn flat @click="saveDeliveryComment" class="bw-5" v-if="action === 'DELIVERY_COMMENT'">Save comment</v-btn>
                  <div v-if="action === 'CREATE_PALLET' || action === 'CREATE_LOOSE_GOODS'" style="padding: 5px 3px 2px 3px; padding-top: 20px;" :key="newPalletKey">
                    <table style="width: 100%;">
                      <tr>
                        <td style="padding: 10px;">
                          <v-layout wrap>
                            <v-flex xs12 sm4 lg2 style="height: 35px;">
                              <v-label v-if="action === 'CREATE_PALLET'">External number</v-label>
                              <v-label v-if="action === 'CREATE_LOOSE_GOODS'">Pallet number</v-label>
                            </v-flex>
                            <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                              <v-text-field v-model="newPallet.externalNumber" maxlength="50" style="max-width: 300px;"/>
                            </v-flex>

                            <v-flex xs12 sm4 lg2 style="height: 35px;">
                              <v-label>Supplier</v-label>
                            </v-flex>
                            <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                              <v-select :items="allSuppliers" v-model="newPallet.supplier" item-text="name" return-object @change="changeSupplierNewPallet()"></v-select>
                            </v-flex>

                            <v-flex xs12 sm4 lg2 style="height: 35px;">
                              <v-label>Field</v-label>
                            </v-flex>
                            <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                              <v-select :items="fieldsNewPallet" v-model="newPallet.field" item-text="address.nameAndText" return-object></v-select>
                            </v-flex>

                            <v-flex xs12 sm4 lg2 style="height: 35px;" v-if="action === 'CREATE_PALLET'">
                              <v-label>Contractor</v-label>
                            </v-flex>
                            <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;" v-if="action === 'CREATE_PALLET'">
                              <v-select :items="contractors" v-model="newPallet.contractor" item-text="name" return-object></v-select>
                            </v-flex>

                            <v-flex xs12 sm4 lg2 style="height: 35px;" v-if="action === 'CREATE_PALLET'">
                              <v-label>Internal carrier</v-label>
                            </v-flex>
                            <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;" v-if="action === 'CREATE_PALLET'">
                              <v-select :items="internalCarriers" v-model="newPallet.internalCarrier" item-text="name" return-object></v-select>
                            </v-flex>

                            <v-flex xs12 sm4 lg2 style="height: 35px;" v-if="action === 'CREATE_PALLET'">
                              <v-label>&frac12; pallet</v-label>
                            </v-flex>
                            <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;" v-if="action === 'CREATE_PALLET'">
                              {{ newPallet.half ? 'Yes' : 'No' }}
                            </v-flex>

                            <v-flex xs12 sm4 lg2 style="height: 35px;" v-if="action === 'CREATE_PALLET'">
                              <v-label>State</v-label>
                            </v-flex>
                            <v-flex xs12 sm8 lg10 style="height: 35px;" v-if="action === 'CREATE_PALLET'">
                              <v-select :items="palletStates" v-model="newPallet.state" item-text="label" item-value="value" style="max-width: 170px;"></v-select>
                            </v-flex>

                            <v-flex xs12 sm4 lg2 style="height: 35px;" v-if="action === 'CREATE_PALLET'">
                              <v-label>Location</v-label>
                            </v-flex>
                            <v-flex xs12 sm8 lg10 style="height: 35px;" v-if="action === 'CREATE_PALLET'">
                              <v-select :items="locationsNewPallet" v-model="newPallet.location" item-text="text" return-object style="line-height: 25px; height: 30px;"></v-select>
                            </v-flex>

                            <v-flex xs12 sm4 lg2 style="height: 35px;" v-if="action === 'CREATE_PALLET'">
                              <v-label>Loading address</v-label>
                            </v-flex>
                            <v-flex xs12 sm8 lg10 style="height: 35px;" v-if="action === 'CREATE_PALLET'">
                              <v-select :items="pickupAddresses" v-model="newPallet.pickupAddress" item-text="text" return-object style="line-height: 25px; height: 30px;"></v-select>
                            </v-flex>

                            <v-flex xs12 sm4 lg2 style="height: 35px;">
                              <v-label>Categories</v-label>
                            </v-flex>
                            <v-flex xs12 sm8 lg10 style="min-height: 35px;">
                              <v-container fluid py-0 px-0>
                                <v-layout wrap v-for="(item, i) in newPallet.items" v-bind:key="item.id">
                                  <v-flex xs12 sm8 style="height: 35px;">
                                    <table style="width: 100%;">
                                      <tr>
                                        <td>
                                          <v-autocomplete :items="item.allCategories ? allCategories : categories" v-model="item.category" item-text="displayLabel" return-object @change="changeCategoryNewPallet(item)">
                                            <template slot="selection" slot-scope="data">
                                              <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                                              <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                                              {{ data.item.displayLabel }}
                                            </template>
                                            <template slot="item" slot-scope="data">
                                              <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                                              <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                                              {{ data.item.displayLabel }}
                                            </template>
                                          </v-autocomplete>
                                        </td>
                                        <td style="width: 160px; padding-left: 20px;" v-if="action === 'CREATE_PALLET'">
                                          <div>
                                            <v-btn @click="showAllCategoriesForNewPallet(item)" v-if="!item.allCategories" class="link" style="width: 130px;">Show all</v-btn>
                                            <v-btn @click="showOrderedCategoriesForNewPallet(item)" v-if="item.allCategories" class="link" style="width: 130px;">Show ordered</v-btn>
                                          </div>
                                        </td>
                                      </tr>
                                    </table>
                                  </v-flex>
                                  <v-flex xs12 sm4 style="height: 35px">
                                    <table style="float: right;">
                                      <tr>
                                        <td style="padding-right: 10px;" v-if="action === 'CREATE_PALLET'">
                                          <v-text-field v-model="item.plannedAmount" style="max-width: 70px;" class="alignRight" title="Planned amount"></v-text-field>
                                        </td>
                                        <td>
                                          <v-text-field v-model="item.amount" style="max-width: 70px;" class="alignRight" title="Produced amount"></v-text-field>
                                        </td>
                                        <td style="width: 25px;">
                                          <v-icon v-if="i > 0 && i === newPallet.items.length - 1" @click="deleteCategoryNewPallet(i)" title="Delete">delete</v-icon>
                                        </td>
                                      </tr>
                                    </table>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-flex>
                          </v-layout>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <v-btn flat @click="addCategoryNewPallet" class="bw-5" v-if="action === 'CREATE_PALLET' || action === 'CREATE_LOOSE_GOODS'">Add category</v-btn>
                  <v-btn flat @click="createNewPallet" class="bw-5" v-if="action === 'CREATE_PALLET'" :disabled="!createNewPalletButtonEnabled">Create pallet</v-btn>
                  <v-btn flat @click="createLooseGoods" class="bw-6" v-if="action === 'CREATE_LOOSE_GOODS'" :disabled="!createLooseGoodsButtonEnabled">Create loose goods</v-btn>
                </v-flex>
              </PanelColumn>
            </Panel>
            <div v-if="currentShipment" :key="deliveryKey">
              <Panel v-if="currentShipment.deliveries" v-for="(delivery, i) in currentShipment.deliveries" v-bind:key="delivery.id">
                <v-flex text-xs-right xs12 v-if="!lockedForEdit">
                  <v-icon v-if="currentShipment && currentShipment.deliveries.length > 1" @click="removeDelivery(i)" title="Delete">delete</v-icon>
                </v-flex>
                <PanelColumn :title="'Delivery no. ' + (i+1)">
                  <v-flex xs12 sm3 lg2 style="height: 35px;">
                    <v-label>Category</v-label>
                  </v-flex>
                  <v-flex xs12 sm8 lg5>
                    <table style="width: 100%;">
                      <tr>
                        <td>
                          <v-autocomplete :items="delivery.allCategories ? allCategories : categories" v-model="delivery.category" item-text="displayLabel" return-object @change="changeCategory(delivery, i)" :disabled="lockedForEdit">
                            <template slot="selection" slot-scope="data">
                              <div v-if="!(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                              <div v-if="data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                              {{ data.item.displayLabel }}
                            </template>
                            <template slot="item" slot-scope="data">
                              <div v-if="!(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                              <div v-if="data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                              {{ data.item.displayLabel }}
                            </template>
                          </v-autocomplete>
                        </td>
                        <td style="width: 160px; padding-left: 20px;">
                          <div>
                            <v-btn @click="showAllCategories(delivery)" v-if="!delivery.allCategories" class="link" style="width: 130px;">Show all</v-btn>
                            <v-btn @click="showOrderedCategories(delivery)" v-if="delivery.allCategories" class="link" style="width: 130px;">Show ordered</v-btn>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </v-flex>

                  <v-flex xs12 lg1 style="height: 10px;">&nbsp;</v-flex>
                  <v-flex xs12 sm3 lg1 style="height: 35px;">
                    <v-label>&frac12; pallet</v-label>
                  </v-flex>
                  <v-flex xs12 sm9 lg1 class="numberOfPallets">
                    <v-checkbox color="teal" v-model="delivery.halfPallet" @change="changeHalfPallet(delivery)" style="margin-left: -2px; padding-top: 0 !important;" :disabled="lockedForEdit"></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm3 lg1 style="height: 35px;">
                    <v-label>Problem</v-label>
                  </v-flex>
                  <v-flex xs12 sm9 lg1 class="numberOfPallets">
                    <v-checkbox color="teal" v-model="delivery.problem" style="margin-left: -2px; padding-top: 0 !important;" :disabled="lockedForEdit"></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm3 lg2 style="height: 35px;">
                    <v-label>Number of pallets</v-label>
                  </v-flex>
                  <v-flex xs12 sm3 lg1 class="numberOfPallets">
                    <v-text-field color="teal" v-model="delivery.numberOfPallets" autocomplete="offit" @change="numberOfPalletsChanged(delivery)" :disabled="lockedForEdit"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 lg1 style="height: 10px;">&nbsp;</v-flex>

                  <v-flex xs12 sm3 lg2 style="height: 35px;">
                    <v-label>Pieces per pallet</v-label>
                  </v-flex>
                  <v-flex xs12 sm3 lg1>
                    <v-text-field color="teal" v-model="delivery.piecesPerPallet" autocomplete="offit" :disabled="lockedForEdit"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 lg1 style="height: 10px;">&nbsp;</v-flex>

                  <v-flex xs12 sm3 lg1>
                    <v-label>Total</v-label>
                  </v-flex>
                  <v-flex xs12 sm9 lg3 style="padding-top: 2px;">
                    {{ palletTotal(delivery) }}
                    <div v-if="capacityForCategory(delivery.category) < 0" style="float: right; color: black; padding: 2px 8px; background-color: rgba(255, 0, 0, 0.3); border: 1px solid #880000; border-radius: 3px; display: inline-block; margin-left: 10px;">
                      {{ -capacityForCategory(delivery.category) }} more than ordered
                    </div>
                    <div v-if="capacityForCategory(delivery.category) > 0" style="float: right; color: black; padding: 2px 8px; background-color: rgba(0, 77, 64, 0.25); border: 1px solid #008800; border-radius: 3px; display: inline-block; margin-left: 10px;">
                      {{ capacityForCategory(delivery.category) }} less than ordered
                    </div>
                  </v-flex>

                  <v-flex xs12 sm3 lg2 style="height: 35px;">
                    <v-label>Supplier</v-label>
                  </v-flex>
                  <v-flex xs12 sm9 lg10 style="height: 35px;">
                    <v-select :items="suppliers[i]" v-model="delivery.supplier" item-text="name" return-object @change="changeSupplier(delivery, i)" :disabled="lockedForEdit">
                      <template slot="selection" slot-scope="data">
                        {{ data.item.name }}
                      </template>
                      <template slot="item" slot-scope="data">
                        <div :style="data.item.preferred ? 'font-weight: bold;' : ''">{{ data.item.name }}</div>
                      </template>
                    </v-select>
                  </v-flex>

                  <v-flex xs12 sm3 lg2 style="height: 35px;">
                    <v-label>Field</v-label>
                  </v-flex>
                  <v-flex xs12 sm9 lg10 style="height: 35px;">
                    <v-select :items="fields[i]" v-model="delivery.field" item-text="address.nameAndText" return-object @change="changeField(delivery, i)" :disabled="lockedForEdit">
                      <template slot="selection" slot-scope="data">
                        <div style="width: 100%;">
                          <div style="display: inline-flex; float: left;">{{ data.item.address.nameAndText }}</div>
                          <div v-if="data.item.availableAmount != null && data.item.labelledAmount && (data.item.availableAmount - palletTotal(delivery) - otherDeliveryTotal(delivery, data.item) < 0)" style="display: inline-flex; float: right; font-weight: bold; font-size: 12px; color: rgba(255, 0, 0, 0.87);">{{ Number(data.item.availableAmount - palletTotal(delivery) - otherDeliveryTotal(delivery, data.item)).toLocaleString() + ' / ' + data.item.labelledAmount.toLocaleString() }}</div>
                          <div v-if="data.item.availableAmount != null && data.item.labelledAmount && (data.item.availableAmount - palletTotal(delivery) - otherDeliveryTotal(delivery, data.item) >= 0)" style="display: inline-flex; float: right; font-weight: normal; font-size: 12px; color: rgba(0, 0, 0, 0.87);">{{ Number(data.item.availableAmount - palletTotal(delivery) - otherDeliveryTotal(delivery, data.item)).toLocaleString() + ' / ' + data.item.labelledAmount.toLocaleString() }}</div>
                        </div>
                      </template>
                      <template slot="item" slot-scope="data">
                        <div :style="(data.item.preferred ? 'font-weight: bold;' : '') + ' width: 100%;'">
                          <div style="display: inline-flex; float: left; width: 12px; line-height: 24px;">{{ (delivery.supplier && delivery.supplier.id === data.item.supplierId ? '*' : '&nbsp;')  }}</div>
                          <div style="display: inline-flex; float: left;">{{ data.item.address.nameAndText }}</div>
                          <div v-if="data.item.availableAmount != null && data.item.labelledAmount && (data.item.availableAmount - otherDeliveryTotal(delivery, data.item)) < 0" style="display: inline-flex; float: right; font-weight: bold; font-size: 12px; color: rgba(255, 0, 0, 0.87);">{{ Number(data.item.availableAmount - otherDeliveryTotal(delivery, data.item)).toLocaleString() + ' / ' + data.item.labelledAmount.toLocaleString() }}</div>
                          <div v-if="data.item.availableAmount != null && data.item.labelledAmount && (data.item.availableAmount - otherDeliveryTotal(delivery, data.item)) >= 0" style="display: inline-flex; float: right; font-weight: normal; font-size: 12px; color: rgba(0, 0, 0, 0.87);">{{ Number(data.item.availableAmount - otherDeliveryTotal(delivery, data.item)).toLocaleString() + ' / ' + data.item.labelledAmount.toLocaleString() }}</div>
                        </div>
                      </template>
                    </v-select>
                  </v-flex>

                  <v-flex xs12 sm3 lg2 style="height: 35px;">
                    <v-label>Loading address</v-label>
                  </v-flex>
                  <v-flex xs12 sm9 lg10 style="height: 35px;">
                    <v-select :items="pickupAddresses" v-model="delivery.pickupAddress" item-text="text" return-object @change="changePickupAddress(delivery, i)" :disabled="lockedForEdit"></v-select>
                  </v-flex>

                  <v-flex xs12 sm3 lg2 style="height: 35px;">
                    <v-label>Delivery address</v-label>
                  </v-flex>
                  <v-flex xs12 sm9 lg10 style="height: 35px;">
                    <v-select :items="deliveryAddresses" v-model="delivery.deliveryAddress" item-text="address.text" return-object @change="changeDeliveryAddress(delivery, i)" :disabled="lockedForEdit"></v-select>
                  </v-flex>

                  <v-flex xs12 sm3 lg2 style="height: 35px;">
                    <v-label>Contractors</v-label>
                  </v-flex>
                  <v-flex xs12 sm9 lg10 style="height: 35px;">
                    <v-select :items="contractors" v-model="delivery.contractors" multiple item-text="name" return-object :disabled="lockedForEdit"></v-select>
                  </v-flex>

                  <v-flex xs12 sm3 lg2 style="height: 35px;">
                    <v-label>Internal carrier</v-label>
                  </v-flex>
                  <v-flex xs12 sm9 lg10 style="height: 35px;">
                    <v-select :items="internalCarriers" v-model="delivery.internalCarrier" item-text="name" return-object :disabled="lockedForEdit"></v-select>
                  </v-flex>

                  <v-flex xs12 sm3 lg2 style="height: 35px;">
                    <v-label>Options</v-label>
                  </v-flex>
                  <v-flex xs12 sm9 lg10 style="height: 35px;">
                    <v-select :items="options" v-model="delivery.options" item-text="name" return-object multiple :disabled="lockedForEdit"/>
                  </v-flex>

                  <v-flex xs12>
                    <v-label>Comments</v-label>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea solo auto-grow flat rows="3" v-model="delivery.comment" :disabled="lockedForEdit"></v-textarea>
                  </v-flex>

                  <v-flex xs12 style="height: 10px;">&nbsp;</v-flex>
                  <v-flex xs12>
                    <v-label>Pallet position</v-label>
                  </v-flex>
                  <v-flex xs12>
                    <table class="palletPosition">
                      <tr>
                        <ShipmentPalletPosition v-model="currentShipment.deliveries[i]" :inUse="positionsInUse" position="1" :disabled="lockedForEdit"/>
                        <ShipmentPalletPosition v-model="currentShipment.deliveries[i]" :inUse="positionsInUse" position="3" :disabled="lockedForEdit"/>
                        <ShipmentPalletPosition v-model="currentShipment.deliveries[i]" :inUse="positionsInUse" position="5" :disabled="lockedForEdit"/>
                        <ShipmentPalletPosition v-model="currentShipment.deliveries[i]" :inUse="positionsInUse" position="7" :disabled="lockedForEdit"/>
                        <ShipmentPalletPosition v-model="currentShipment.deliveries[i]" :inUse="positionsInUse" position="9" :disabled="lockedForEdit"/>
                      </tr>
                      <tr>
                        <ShipmentPalletPosition v-model="currentShipment.deliveries[i]" :inUse="positionsInUse" position="2" :disabled="lockedForEdit"/>
                        <ShipmentPalletPosition v-model="currentShipment.deliveries[i]" :inUse="positionsInUse" position="4" :disabled="lockedForEdit"/>
                        <ShipmentPalletPosition v-model="currentShipment.deliveries[i]" :inUse="positionsInUse" position="6" :disabled="lockedForEdit"/>
                        <ShipmentPalletPosition v-model="currentShipment.deliveries[i]" :inUse="positionsInUse" position="8" :disabled="lockedForEdit"/>
                        <ShipmentPalletPosition v-model="currentShipment.deliveries[i]" :inUse="positionsInUse" position="10" :disabled="lockedForEdit"/>
                      </tr>
                    </table>
                  </v-flex>
                </PanelColumn>
              </Panel>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentShipment && viewLog">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn :title="'Log entries for shipment ' + this.currentShipment.number">
                <v-layout style="max-height: calc(100vh - 290px);">
                  <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
                    <v-data-table :headers="logHeaders" :items="logs" hide-actions class="palletTable" no-data-text="No log entries found">
                      <template v-slot:items="props">
                        <tr>
                          <td class="text-xs-left" style="width: 160px;">{{ props.item.timestamp }}</td>
                          <td class="text-xs-left">{{ props.item.userFullName }}</td>
                          <td class="text-xs-left colMessage">{{ props.item.palletNumber }}</td>
                          <td class="text-xs-left">{{ props.item.message }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Delete shipment</v-card-title>
        <v-card-text v-if="currentShipment">Are you sure you want to delete this shipment?</v-card-text>
        <v-card-text v-if="currentShipment && this.currentShipment.state !== 'PLANNED'" style="padding-top: 0;">Please note that production has already started and you might loose data about this shipment.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.delete">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="printDeliveryNoteDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Print delivery note</v-card-title>
        <v-card-text>
          <div style="padding: 5px 20px 0 20px;">
            <v-checkbox v-model="printDeliveryNoteWithDetails" label="Include supplier and field" color="teal"></v-checkbox>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="printDeliveryNote" class="bw-3">Print</v-btn>
          <v-btn flat @click="printDeliveryNoteDialog = false" class="bw-3">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmLoadingComplete" persistent width="450">
      <v-card pa-5>
        <v-card-title class="headline">Loading complete</v-card-title>
        <v-card-text>Are you sure you want to complete loading on this shipment?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.loadingComplete">Yes</v-btn>
          <v-btn flat @click="confirmLoadingComplete = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorDialog ref="errorDialog"/>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import ErrorDialog from '../components/ErrorDialog'
import PanelColumn from '../components/PanelColumn'
import PalletItems from '../components/PalletItems'
import ShipmentLooseGoods from '../components/ShipmentLooseGoods'
import ShipmentPallet from '../components/ShipmentPallet'
import ShipmentPalletOrder from '../components/ShipmentPalletOrder'
import ShipmentPalletPosition from '../components/ShipmentPalletPosition'
import axios from 'axios'
import DateUtil from '@/assets/javascript/dateutil'
import NumberUtil from '@/assets/javascript/numberutil'
import Draggable from 'vuedraggable'

export default {
  name: 'Shipments',
  components: { Header, Sidebar, Footer, Panel, PanelColumn, PalletItems, ShipmentLooseGoods, ShipmentPallet, ShipmentPalletOrder, ShipmentPalletPosition, ErrorDialog, Draggable },
  data () {
    return {
      search: '',
      currentPage: 1,
      lastPage: 0,
      shipmentsPerPage: 50,
      headers: [
        { text: 'No.', value: 'number', sortable: true },
        { text: 'State', value: 'state', sortable: true },
        { text: 'Customer', value: 'customerName', sortable: true },
        { text: 'Loading address', value: 'pickupAddresses', sortable: false },
        { text: 'Supplier', value: 'suppliers', sortable: false },
        { text: 'Field', value: 'fields', sortable: false },
        { text: 'Category', value: 'categories', sortable: false },
        { text: 'Amount', value: 'amounts', sortable: false },
        { text: 'Loading date', value: 'pickupDate', sortable: true },
        { text: 'Delivery date', value: 'deliveryDate', sortable: true },
        { text: 'Carrier', value: 'carrierName', sortable: true }
      ],
      headersNoSorting: [
        { text: 'No.', value: 'number', sortable: false },
        { text: 'State', value: 'state', sortable: false },
        { text: 'Customer', value: 'customerName', sortable: false },
        { text: 'Loading address', value: 'pickupAddresses', sortable: false },
        { text: 'Supplier', value: 'suppliers', sortable: false },
        { text: 'Field', value: 'fields', sortable: false },
        { text: 'Category', value: 'categories', sortable: false },
        { text: 'Amount', value: 'amounts', sortable: false },
        { text: 'Loading date', value: 'pickupDate', sortable: false },
        { text: 'Delivery date', value: 'deliveryDate', sortable: false },
        { text: 'Carrier', value: 'carrierName', sortable: false }
      ],
      inStockPalletHeaders: [
        { text: '', sortable: false },
        { text: 'Pallet no.', value: 'number', sortable: false },
        { text: 'State', value: 'state', sortable: false },
        { text: 'Category', value: 'categories', sortable: false },
        { text: 'Amount', value: 'amounts', sortable: false }
      ],
      palletStates: [
        { value: 'PLANNED', label: 'Planned' },
        { value: 'IN_PRODUCTION', label: 'In production' },
        { value: 'PRODUCED', label: 'Produced' },
        { value: 'READY_FOR_PICKUP', label: 'Ready for pickup' },
        { value: 'IN_TRANSPORT', label: 'In transport' },
        { value: 'REPACKED', label: 'Repacked' },
        { value: 'DELIVERED', label: 'Delivered' }
      ],
      logHeaders: [
        { text: 'Timestamp', value: 'timestamp', sortable: false },
        { text: 'User', value: 'userFullName', sortable: false },
        { text: 'Pallet', value: 'palletNumber', sortable: false },
        { text: 'Message', value: 'message', sortable: false }
      ],
      shipments: [],
      categories: [],
      allCategories: [],
      filterCustomers: [],
      filterCustomer: { id: 0 },
      filterSuppliers: [],
      filterSupplier: { id: 0 },
      filterCategories: [],
      filterCategory: { id: 0 },
      hasShipmentsAwaitingApproval: false,
      customers: [],
      carriers: [],
      types: [],
      assignees: [],
      allSuppliers: [],
      contractors: [],
      internalCarriers: [],
      suppliers: [],
      fields: [],
      fieldsNewPallet: [],
      locationsNewPallet: [],
      palletOrders: [],
      pallets: [],
      pickupAddresses: [],
      deliveryAddresses: [],
      currentShipment: null,
      currentPallet: null,
      currentPalletPosition: null,
      newPallet: null,
      action: null,
      stockAddress: null,
      palletAddress: null,
      palletPickupAddress: null,
      palletInternalCarrier: null,
      palletsInStock: [],
      stockPallet: null,
      approvalStarted: false,
      approvalEmail: '',
      approvalSubject: '',
      approvalMessage: '',
      sendStarted: false,
      sendEmail: '',
      sendSubject: '',
      sendMessage: '',
      confirmLoadingComplete: false,
      confirmDeleteDialog: false,
      pickupDate: '',
      pickupTime: '',
      pickupDateMenu: false,
      pickupTimeMenu: false,
      deliveryDate: '',
      deliveryTime: '',
      deliveryDateMenu: false,
      deliveryTimeMenu: false,
      deliveries: [],
      deliveryKey: 0,
      newPalletKey: 0,
      palletOrderPositions: [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
      ],
      palletPositions: [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
      ],
      filterDelivered: false,
      printDeliveryNoteDialog: false,
      printDeliveryNoteWithDetails: false,
      loadPalletNumber: '',
      palletsByNumber: [],
      chosenPallet: null,
      capacities: null,
      customerOrder: null,
      logs: [],
      viewLog: false,
      deliveryComment: '',
      options: [],
      deliveryAddressOrderUpdateKey: 1,
      creatingInvoice: false
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'shipments' })
    this.currentShipment = null
    this.loadCustomers()
    this.loadCarriers()
    this.loadPickupAddresses()
    this.loadShipments()
    this.loadAllSuppliers()
    this.loadContractors()
    this.loadInternalCarriers()
    this.loadOptions()
    this.loadFilterCustomers()
    this.loadFilterSuppliers()
    this.loadFilterCategories()
  },
  computed: {
    saveButtonEnabled: function () {
      let val = this.currentShipment.number !== '' && this.currentShipment.customer && this.currentShipment.customer.id > 0
      if (val) {
        // Check all deliveries
        if (this.currentShipment.deliveries) {
          for (let delivery of this.currentShipment.deliveries) {
            val = val && (delivery.category && delivery.category.id > 0)
            val = val && (delivery.numberOfPallets && delivery.numberOfPallets > 0)
          }
        }
      }
      return val
    },
    canUpdate: function () {
      return this.currentShipment
    },
    canDelete: function () {
      return this.currentShipment && this.currentShipment.id > 0
    },
    canAddDelivery: function () {
      return this.currentShipment && this.currentShipment.state !== 'DELIVERED'
    },
    canCompleteLoading: function () {
      return this.currentShipment && !this.canApprove && this.currentShipment.state !== 'DELIVERED' && this.hasPallets
    },
    canApprove: function () {
      return this.currentShipment && this.currentShipment.state === 'DELIVERED' && !this.currentShipment.approved && !this.isInternalTransportShipment
    },
    canSend: function () {
      return this.currentShipment && this.currentShipment.state === 'DELIVERED' && this.currentShipment.approved && !this.isInternalTransportShipment
    },
    canCreateInvoice: function () {
      return this.currentShipment && this.currentShipment.state === 'DELIVERED' && this.currentShipment.approved && !this.isInternalTransportShipment
    },
    canViewLog: function () {
      return this.currentShipment && this.currentShipment.id
    },
    canPrintDeliveryNote: function () {
      return this.currentShipment && this.currentShipment.id > 0 && this.currentShipment.state !== 'PLANNED' && this.currentShipment.state !== 'IN_PRODUCTION' && !this.isInternalTransportShipment
    },
    lockedForEdit: function () {
      return this.currentShipment && this.currentShipment.state === 'DELIVERED'
    },
    lockedForUpdate: function () {
      return !this.canUpdate
    },
    positionsInUse: function () {
      let positionsInUse = []
      if (this.currentShipment && this.currentShipment.deliveries) {
        for (let delivery of this.currentShipment.deliveries) {
          for (let i in delivery.positions) {
            if (delivery.positions[i] && !positionsInUse.includes(Number(i) + 1)) {
              positionsInUse.push(Number(i) + 1)
            }
            if (!delivery.halfPallet && i < 10 && delivery.positions[i] && !positionsInUse.includes(Number(i) + 1 + 10)) {
              positionsInUse.push(Number(i) + 1 + 10)
            }
          }
        }
      }
      return positionsInUse
    },
    tableHeaders: function () {
      return this.hasShipmentsAwaitingApproval ? this.headersNoSorting : this.headers
    },
    sortTable: function () {
      return !this.hasShipmentsAwaitingApproval
    },
    approvalEmailCorrect: function () {
      return this.approvalEmail && this.approvalEmail.trim() !== ''
    },
    sendEmailCorrect: function () {
      return this.sendEmail && this.sendEmail.trim() !== ''
    },
    createNewPalletButtonEnabled: function () {
      let enabled = true
      enabled = enabled && (this.newPallet.supplier && this.newPallet.supplier.id > 0)
      enabled = enabled && (this.newPallet.field && this.newPallet.field.id > 0)
      enabled = enabled && (this.newPallet.pickupAddress && this.newPallet.pickupAddress.id > 0)
      enabled = enabled && (this.newPallet.contractor && this.newPallet.contractor.id > 0)
      for (let item of this.newPallet.items) {
        enabled = enabled && (item && item.category && item.category.id > 0)
      }
      return enabled
    },
    createLooseGoodsButtonEnabled: function () {
      let enabled = true
      enabled = enabled && (this.newPallet.supplier && this.newPallet.supplier.id > 0)
      for (let item of this.newPallet.items) {
        enabled = enabled && (item && item.category && item.category.id > 0 && item.amount && NumberUtil.isPositiveInteger(item.amount))
      }
      return enabled
    },
    buttonStyleFilterProduction () {
      return (this.filterDelivered === false ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterDelivered () {
      return (this.filterDelivered === true ? ' color: #606060 !important;' : '')
    },
    hasMissingCategories () {
      if (this.pallets) {
        for (let pallet of this.pallets) {
          if (pallet.items) {
            for (let item of pallet.items) {
              if (!item.category) {
                return true
              }
            }
          }
        }
      }
      return false
    },
    hasPotentialIncorrectDates () {
      if (this.pickupDate !== '' && this.pickupTime !== '' && this.deliveryDate !== '' && this.deliveryTime !== '') {
        let now = new Date()
        let yesterday = new Date()
        yesterday.setDate(now.getDate() - 1)
        let fiveDaysFromNow = new Date()
        fiveDaysFromNow.setDate(now.getDate() + 5)
        let pickupDatetime = DateUtil.timeStringToDate(this.pickupDate + ' ' + this.pickupTime)
        let deliveryDatetime = DateUtil.timeStringToDate(this.deliveryDate + ' ' + this.deliveryTime)
        if (pickupDatetime > now) {
          // Pickup date is in the future
          return true
        }
        if (pickupDatetime < yesterday) {
          // Pickup date is more than a day ago
          return true
        }
        if (!(deliveryDatetime > pickupDatetime)) {
          // Delivery date is not later than pickup date
          return true
        }
        if (deliveryDatetime > fiveDaysFromNow) {
          // Delivery date is more than five days from now
          return true
        }
        return false
      }
      return true
    },
    hasPalletOrders () {
      return this.palletOrders && this.palletOrders.length > 0
    },
    hasPallets () {
      return this.pallets && this.pallets.length > 0
    },
    hasPositionedPallets () {
      if (this.hasPallets) {
        for (let pallet of this.pallets) {
          if (pallet.position > 0) {
            return true
          }
        }
      }
      return false
    },
    hasLooseGoods () {
      if (this.hasPallets) {
        for (let pallet of this.pallets) {
          if (pallet.position === 0) {
            return true
          }
        }
      }
      return false
    },
    looseGoodsPallets () {
      if (this.pallets && this.pallets.length > 0) {
        return this.pallets.filter(p => p.position === 0)
      }
      return []
    },
    hasMultipleDeliveryAddresses () {
      return this.deliveryAddressOrderUpdateKey && this.currentShipment && this.currentShipment.deliveryAddressOrders && this.currentShipment.deliveryAddressOrders.length > 1
    },
    isShowingDeliveredShipments: function () {
      return this.filterDelivered
    },
    pagedShipments () {
      if (this.filteredShipments) {
        let start = (this.currentPage - 1) * this.shipmentsPerPage
        let end = start + this.shipmentsPerPage
        return this.filteredShipments.slice(start, end)
      }
      return []
    },
    filteredShipments () {
      let shipments = []
      if (this.shipments && this.search !== '') {
        let searchString = this.search.toLowerCase()
        for (let s of this.shipments) {
          if ((s.number && s.number.toLowerCase().includes(searchString)) ||
            (s.state && this.stateLabel(s.state).toLowerCase().includes(searchString)) ||
            (s.customerName && s.customerName.toLowerCase().includes(searchString)) ||
            (s.search && s.search.includes(searchString)) ||
            (s.categories && s.categories.toLowerCase().includes(searchString)) ||
            (s.amounts && s.amounts.toLowerCase().includes(searchString)) ||
            (s.pickupDate && s.pickupDate.toLowerCase().includes(searchString)) ||
            (s.deliveryDate && s.deliveryDate.toLowerCase().includes(searchString)) ||
            (s.carrierName && s.carrierName.toLowerCase().includes(searchString))) {
            shipments.push(s)
          }
        }
      } else {
        shipments = this.shipments
      }
      // console.log('Number of shipments: ' + shipments.length)
      return shipments
    },
    isInternalTransportShipment () {
      return this.currentShipment && this.currentShipment.internalTransport
    }
  },
  methods: {
    pickupAllowedSteps: m => m % 5 === 0,
    deliveryAllowedSteps: m => m % 5 === 0,
    changeCustomer () {
      this.loadCategories()
      this.loadDeliveryAddresses()
      this.loadCapacities()
      this.loadCustomerOrder()
    },
    changeCategory (delivery, index) {
      this.changeHalfPallet(delivery)

      delivery.supplier = null
      delivery.field = null

      this.loadSuppliers(delivery, index)
      this.loadFields(delivery, index, true)
    },
    changeHalfPallet (delivery) {
      delivery.piecesPerPallet = delivery.halfPallet ? delivery.category.halfPalletAmount : delivery.category.palletAmount
      if (this.customerOrder && this.customerOrder.items) {
        for (let item of this.customerOrder.items) {
          if (item.category && item.category.id === delivery.category.id) {
            if (delivery.halfPallet && item.halfPalletAmount && item.halfPalletAmount > 0) {
              delivery.piecesPerPallet = item.halfPalletAmount
            } else if (!delivery.halfPallet && item.palletAmount && item.palletAmount > 0) {
              delivery.piecesPerPallet = item.palletAmount
            }
            break
          }
        }
      }
      if (isNaN(delivery.piecesPerPallet)) {
        delivery.piecesPerPallet = 0
      }
    },
    changeSupplier (delivery, index) {
      delivery.field = {}
      let allSuppliers = !(delivery.supplier && delivery.supplier.id > 0)
      this.loadFields(delivery, index, allSuppliers)
      if (delivery.supplier && delivery.supplier.contractors && delivery.supplier.contractors.length) {
        delivery.contractors = delivery.supplier.contractors
      }
    },
    changeField (delivery, index) {
      if (this.suppliers && this.suppliers.length > 0 && this.suppliers[index] && this.suppliers[index].length > 0) {
        let supplierId = delivery.field && delivery.field.supplierId > 0 ? delivery.field.supplierId : 0
        if (supplierId > 0) {
          for (let supplier of this.suppliers[index]) {
            if (supplier.id === supplierId) {
              delivery.supplier = supplier
              break
            }
          }
        }
      }
      if (this.fields && this.fields.length > 0 && this.fields[index] && this.fields[index].length > 0) {
        let pickupAddressId = delivery.field && delivery.field.pickupAddress && delivery.field.pickupAddress.id > 0 ? delivery.field.pickupAddress.id : 0
        for (let field of this.fields[index]) {
          if (field.pickupAddress && field.pickupAddress.id === pickupAddressId) {
            delivery.pickupAddress = field.pickupAddress
            break
          }
        }
      }
    },
    changePickupAddress (delivery, index) {
    },
    changeDeliveryAddress (delivery, index) {
      this.updateDeliveryAddressOrders()
    },
    loadCustomers () {
      // console.log('Loading customers')
      axios.get('/backend/rest/customer')
        .then(response => {
          // console.log('Assignees: ' + JSON.stringify(response.data))
          this.customers = response.data
        })
    },
    loadCarriers () {
      // console.log('Loading carriers')
      axios.get('/backend/rest/carrier')
        .then(response => {
          // console.log('Assignees: ' + JSON.stringify(response.data))
          this.carriers = response.data
        })
    },
    loadAllSuppliers () {
      // console.log('Loading suppliers')
      axios.get('/backend/rest/supplier')
        .then(response => {
          // console.log('Suppliers: ' + JSON.stringify(response.data))
          this.allSuppliers = response.data
          this.allSuppliers.splice(0, 0, {
            id: 0,
            name: ''
          })
        })
    },
    loadOptions () {
      axios.get('/backend/rest/option')
        .then(response => {
          this.options = response.data
        })
    },
    loadFilterCustomers () {
      axios.get('/backend/rest/customer')
        .then(response => {
          let filterCustomers = response.data
          filterCustomers.splice(0, 0, {
            id: 0,
            name: ''
          })
          filterCustomers.sort(function (f1, f2) {
            return f1.name.localeCompare(f2.name)
          })
          this.filterCustomers = filterCustomers
        })
    },
    loadFilterSuppliers () {
      // console.log('Loading filter suppliers')
      axios.get('/backend/rest/supplier')
        .then(response => {
          // console.log('Filter categories: ' + JSON.stringify(response.data))
          this.filterSuppliers = response.data
          this.filterSuppliers.splice(0, 0, {
            id: 0,
            name: ''
          })
        })
    },
    loadContractors () {
      // console.log('Loading contractors')
      axios.get('/backend/rest/contractor')
        .then(response => {
          this.contractors = response.data
          this.contractors.splice(0, 0, {
            id: 0,
            name: ''
          })
        })
    },
    loadInternalCarriers () {
      // console.log('Loading internal carriers')
      axios.get('/backend/rest/carrier')
        .then(response => {
          this.internalCarriers = response.data
          this.internalCarriers.splice(0, 0, {
            id: 0,
            name: ''
          })
        })
    },
    loadSuppliers (delivery, index) {
      // console.log('Loading suppliers for delivery at index ' + index)
      let suppliers = []
      let fields = []
      this.$set(this.suppliers, index, suppliers)
      this.$set(this.fields, index, fields)

      if (this.lockedForEdit) {
        if (delivery.supplier) {
          suppliers.push(delivery.supplier)
        }
        this.$set(this.suppliers, index, suppliers)
      } else if (this.currentShipment.customer && this.currentShipment.customer.id > 0 && delivery.category && delivery.category.id > 0) {
        axios.get('/backend/rest/supplier/customer/' + this.currentShipment.customer.id + '/category/' + delivery.category.id + '/delivery/' + (delivery.id > 0 ? delivery.id : 0))
          .then(response => {
            suppliers = response.data

            if (suppliers && suppliers.length > 0) {
              if (suppliers && suppliers.length === 1) {
                delivery.supplier = suppliers[0]
                this.loadFields(delivery, index)
              }

              suppliers.splice(0, 0, {
                id: 0,
                name: ''
              })
              this.$set(this.suppliers, index, suppliers)
            } else {
              this.$set(this.fields, index, [])
              delivery.supplier = null
              delivery.field = null
            }
          })
      }
    },
    loadFields (delivery, index, allSuppliers = false) {
      let fields = []
      this.$set(this.fields, index, fields)

      if (this.lockedForEdit) {
        if (delivery.field) {
          fields.push(delivery.field)
        }
        this.$set(this.fields, index, fields)
      } else if ((allSuppliers || (delivery.supplier && delivery.supplier.id > 0)) && delivery.category && delivery.category.id > 0 && this.currentShipment.customer && this.currentShipment.customer.id > 0) {
        let supplierId = allSuppliers ? 0 : delivery.supplier.id
        axios.get('/backend/rest/field/supplier/' + supplierId + '/customer/' + this.currentShipment.customer.id + '/category/' + delivery.category.id + '/shipment/' + this.currentShipment.id + '/delivery/' + (delivery.id > 0 ? delivery.id : 0))
          .then(response => {
            fields = response.data
            fields.splice(0, 0, {
              id: 0,
              address: {
                nameAndText: ''
              }
            })
            this.$set(this.fields, index, fields)
          })
      }
    },
    loadPickupAddresses () {
      // console.log('Loading pickup addresses')
      axios.get('/backend/rest/pickup_address')
        .then(response => {
          // console.log('Pickup addresses: ' + JSON.stringify(response.data))
          this.pickupAddresses = response.data
          if (this.pickupAddresses && this.pickupAddresses.length > 0) {
            this.stockAddress = this.pickupAddresses[0]
            this.palletAddress = this.pickupAddresses[0]
            this.palletPickupAddress = this.pickupAddresses[0]
          }
          this.pickupAddresses.splice(0, 0, {
            id: 0,
            text: ''
          })
        })
    },
    loadPalletOrdersForShipment () {
      this.palletOrders = []
      if (this.currentShipment) {
        // console.log('Loading pallets for shipment ' + this.currentShipment.id)
        for (let i = 0; i < 20; i++) {
          this.$set(this.palletOrderPositions, i, {})
        }
        axios.get('/backend/rest/pallet_order/shipment/' + this.currentShipment.id)
          .then(response => {
            // console.log('Pallets: ' + JSON.stringify(response.data))
            this.palletOrders = response.data

            if (this.palletOrders && this.palletOrders.length > 0) {
              for (let palletOrder of this.palletOrders) {
                // console.log('Set pallet on position ' + (pallet.position - 1))
                this.$set(this.palletOrderPositions, palletOrder.position - 1, palletOrder)
              }
            }
          })
      }
    },
    loadPalletsForShipment () {
      this.pallets = []
      if (this.currentShipment) {
        // console.log('Loading pallets for shipment ' + this.currentShipment.id)
        for (let i = 0; i < 20; i++) {
          this.$set(this.palletPositions, i, {})
        }
        axios.get('/backend/rest/pallet/shipment/' + this.currentShipment.id)
          .then(response => {
            // console.log('Pallets: ' + JSON.stringify(response.data))
            let pallets = response.data
            if (pallets.length === 0) {
              pallets = [ {} ]
            }
            for (let pallet of pallets) {
              // console.log('Set pallet on position ' + (pallet.position - 1) + ': ' + JSON.stringify(pallet))
              this.$set(this.palletPositions, pallet.position - 1, pallet)
            }
            this.pallets = pallets
          })
      }
    },
    loadDeliveryAddresses () {
      if (this.currentShipment && this.currentShipment.customer) {
        // console.log('Loading delivery addresses')
        axios.get('/backend/rest/delivery_address/customer/' + this.currentShipment.customer.id)
          .then(response => {
            // console.log('Delivery addresses: ' + JSON.stringify(response.data))
            this.deliveryAddresses = response.data

            if (this.deliveryAddresses && this.deliveryAddresses.length === 1) {
              for (let delivery of this.currentShipment.deliveries) {
                delivery.deliveryAddress = this.deliveryAddresses[0]
              }
            }

            this.deliveryAddresses.splice(0, 0, {
              id: 0,
              address: {
                text: ''
              }
            })
          })
      }
    },
    loadCategories () {
      // console.log('Loading categories')
      this.categories = []
      this.allCategories = []
      if (this.lockedForEdit) {
        axios.get('/backend/rest/category/all')
          .then(response => {
            this.categories = response.data
          })
      } else if (this.currentShipment && this.currentShipment.customer) {
        axios.get('/backend/rest/category/customer/' + this.currentShipment.customer.id)
          .then(response => {
            this.categories = response.data
            if (this.currentShipment.deliveries) {
              for (let delivery of this.currentShipment.deliveries) {
                delivery.allCategories = delivery.category && this.categories.filter(c => !delivery.category || delivery.category.id === 0 || c.id === delivery.category.id).length === 0
              }
            }
          })
      }
      axios.get('/backend/rest/category')
        .then(response => {
          this.allCategories = response.data
        })
    },
    loadFilterCategories () {
      // console.log('Loading filter categories')
      axios.get('/backend/rest/category')
        .then(response => {
          // console.log('Filter categories: ' + JSON.stringify(response.data))
          this.filterCategories = response.data
          this.filterCategories.splice(0, 0, {
            id: 0,
            displayLabel: ''
          })
        })
    },
    loadShipments (success) {
      let url = '/backend/rest/shipment/summary?customer=' + this.filterCustomer.id + '&supplier=' + this.filterSupplier.id + '&category=' + (this.filterCategory ? this.filterCategory.id : 0) + '&delivered=' + this.filterDelivered + '&internalTransport=false'
      axios.get(url)
        .then(response => {
          this.shipments = response.data
          if (this.shipments.length > 0) {
            this.hasShipmentsAwaitingApproval = this.shipments[0].awaitingApproval
          }
          this.lastPage = Math.ceil(this.filteredShipments.length / this.shipmentsPerPage)
          if (this.currentPage > this.lastPage) {
            this.currentPage = 1
          }
          this.search = ''

          if (success) {
            success(this)
          }
        })
    },
    loadShipment (shipmentId, success) {
      // console.log('Loading shipment')
      axios.get('/backend/rest/shipment/' + shipmentId)
        .then(response => {
          // console.log('Got shipment: ' + JSON.stringify(response.data))
          this.currentShipment = response.data
          this.pickupDate = DateUtil.datetimeToDate(this.currentShipment.pickupDate)
          this.pickupTime = DateUtil.datetimeToTime(this.currentShipment.pickupDate)
          this.deliveryDate = DateUtil.datetimeToDate(this.currentShipment.deliveryDate)
          this.deliveryTime = DateUtil.datetimeToTime(this.currentShipment.deliveryDate)

          // console.log('The current shipment is: ' + this.currentShipment.id)

          if (success) {
            success(this)
          }
        })
    },
    loadShipmentState () {
      axios.get('/backend/rest/shipment/' + this.currentShipment.id)
        .then(response => {
          let shipment = response.data
          this.currentShipment.state = shipment.state
        })
    },
    loadCustomerOrder () {
      // console.log('Loading customers')
      if (this.currentShipment && this.currentShipment.customer) {
        axios.get('/backend/rest/customer_order/customer/' + this.currentShipment.customer.id)
          .then(response => {
            this.customerOrder = response.data
          })
      }
    },
    resetPalletPositions () {
      // console.log('Resetting ' + this.palletPositions.length + ' pallet positions')
      for (let i in this.palletOrderPositions) {
        this.$set(this.palletOrderPositions, i, {})
      }
      for (let i in this.palletPositions) {
        this.$set(this.palletPositions, i, {})
      }
    },
    previousPage () {
      if (this.currentPage > 1) {
        this.currentPage -= 1
      }
    },
    nextPage () {
      if (this.currentPage < this.lastPage) {
        this.currentPage += 1
      }
    },
    selectShipment (item) {
      this.currentPallet = null
      this.action = null
      this.resetPalletPositions()
      this.loadShipment(item.id, function (t) {
        t.loadPalletOrdersForShipment()
        t.loadPalletsForShipment()
        t.loadCategories()
        t.loadDeliveryAddresses()
        for (let i in t.currentShipment.deliveries) {
          let delivery = t.currentShipment.deliveries[i]
          let allSuppliers = !(delivery.supplier && delivery.supplier.id > 0)
          t.loadSuppliers(delivery, i)
          t.loadFields(delivery, i, allSuppliers)
        }
        t.loadCapacities()
        t.loadCustomerOrder()
      })
    },
    editNewShipment () {
      // console.log('Create a new shipment')
      this.pickupDate = ''
      this.pickupTime = ''
      this.deliveryDate = ''
      this.deliveryTime = ''
      this.palletOrders = []
      this.pallets = []
      this.action = null
      this.currentPallet = null
      this.categories = []
      this.fields = [
        []
      ]
      this.currentShipment = {
        id: 0,
        state: 'DRAFT',
        number: '',
        customer: {},
        carrier: {},
        pickupDate: '',
        deliveryDate: '',
        licensePlate: '',
        comment: '',
        fixedPalletPositions: false,
        deliveries: [
          {
            id: 0,
            supplier: {},
            field: {},
            pickupAddress: {},
            contractors: [],
            deliveryAddress: {},
            comment: '',
            category: {
              id: 0
            },
            allCategories: false,
            numberOfPallets: 0,
            piecesPerPallet: 0,
            positions: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false]
          }
        ]
      }
    },
    print () {
      let shipmentIds = []
      for (let shipment of this.filteredShipments) {
        shipmentIds.push(shipment.id)
      }
      let params = 'shipments=' + shipmentIds.join(',')
      axios.post('/backend/print/shipments.xhtml', params, {responseType: 'blob'})
        .then((response) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/pdf' }), 'Shipments.pdf')
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Shipments.pdf')
            document.body.appendChild(link)
            link.click()
          }
        })
    },
    toggleFilterDelivered (delivered) {
      this.filterDelivered = delivered
      this.loadShipments()
    },
    addDelivery () {
      this.fields.push(this.fields[this.fields.length - 1])
      let delivery = JSON.parse(JSON.stringify(this.currentShipment.deliveries[this.currentShipment.deliveries.length - 1]))
      delivery.id = -this.currentShipment.deliveries.length
      delivery.category = {}
      delivery.options = []
      delivery.field = {}
      delivery.pickupAddress = {}
      delivery.contractors = []
      delivery.numberOfPallets = 1
      delivery.piecesPerPallet = 0
      delivery.problem = false
      delivery.positions = [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false]
      this.currentShipment.deliveries.push(delivery)
      this.updateDeliveryAddressOrders()
      // console.log('Number of deliveries is now ' + this.currentShipment.deliveries.length)
    },
    removeDelivery (index) {
      if (this.currentShipment.deliveries.length > 1) {
        this.currentShipment.deliveries.splice(index, 1)
      }
      this.updateDeliveryAddressOrders()
    },
    togglePosition (delivery, index) {
      let newValue = !delivery.positions[index]
      if (!newValue || this.numberOfPositions(delivery) < Math.ceil(delivery.numberOfPallets)) {
        this.$set(delivery.positions, index, newValue)
      }
    },
    numberOfPositions (delivery) {
      let count = 0
      for (let pos of delivery.positions) {
        if (pos) {
          count++
        }
      }
      // console.log('Number of positions: ' + count)
      return count
    },
    numberOfPalletsChanged (delivery) {
      while (Math.ceil(delivery.numberOfPallets) < this.numberOfPositions(delivery)) {
        for (let i = delivery.positions.length - 1; i >= 0; i--) {
          if (delivery.positions[i]) {
            this.$set(delivery.positions, i, false)
            break
          }
        }
      }
    },
    reloadCurrentShipment () {
      // console.log('Reloading current shipment')
      axios.get('/backend/rest/shipment/' + this.currentShipment.id)
        .then(response => {
          this.currentShipment = response.data
          for (let i in this.currentShipment.deliveries) {
            this.$set(this.currentShipment.deliveries, i, this.currentShipment.deliveries[i])
          }
          this.resetPalletPositions()
          this.loadPalletOrdersForShipment()
          this.loadPalletsForShipment()
        })
    },
    selectShipmentForCurrentShipment () {
      // console.log('Select current shipment: ' + this.currentShipment)
      this.selectShipment(this.currentShipment)
    },
    save () {
      // console.log('Save shipment: ' + JSON.stringify(this.currentShipment))
      this.currentShipment.pickupDate = this.pickupDate + ' ' + this.pickupTime
      this.currentShipment.deliveryDate = this.deliveryDate + ' ' + this.deliveryTime
      for (let delivery of this.currentShipment.deliveries) {
        delete delivery.allCategories
      }

      axios.post('/backend/rest/shipment', this.currentShipment)
        .then(response => {
          // console.log('Got response: ' + response)
          this.loadShipments()
          this.currentShipment = null
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
    },
    delete () {
      // console.log('Delete shipment: ' + this.currentShipment.id)
      axios.delete('/backend/rest/shipment/' + this.currentShipment.id)
        .then(response => {
          // console.log('Got response: ' + response)
          this.loadShipments()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteDialog = false
      this.currentShipment = null
    },
    startApprove () {
      this.approvalStarted = true
      this.approvalEmail = this.currentShipment.customer.email
      let locale = this.currentShipment.customer.locale
      if (locale === '') {
        locale = 'en'
      }
      this.approvalSubject = ''
      this.approvalMessage = ''
      axios.get('/backend/rest/shipment/' + this.currentShipment.id + '/approval_info')
        .then(response => {
          this.approvalSubject = response.data.subject
          this.approvalMessage = response.data.message
        })
    },
    startSend () {
      this.sendStarted = true
      this.sendEmail = this.currentShipment.customer.email
      let locale = this.currentShipment.customer.locale
      if (locale === '') {
        locale = 'en'
      }
      this.sendSubject = ''
      this.sendMessage = ''
      axios.get('/backend/rest/shipment/' + this.currentShipment.id + '/approval_info')
        .then(response => {
          this.sendSubject = response.data.subject
          this.sendMessage = response.data.message
        })
    },
    approveAndSend () {
      let shipmentApprove = {
        shipmentId: this.currentShipment.id,
        sendEmail: true,
        email: this.approvalEmail,
        subject: this.approvalSubject,
        message: this.approvalMessage,
        pickupDate: this.pickupDate + ' ' + this.pickupTime,
        deliveryDate: this.deliveryDate + ' ' + this.deliveryTime
      }
      axios.post('/backend/rest/shipment/' + this.currentShipment.id + '/approve', shipmentApprove)
        .then(response => {
          this.loadShipments(() => {
            this.selectShipmentForCurrentShipment()
            this.approvalStarted = false
          })
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
    },
    approveOnly () {
      let shipmentApprove = {
        shipmentId: this.currentShipment.id,
        sendEmail: false,
        pickupDate: this.pickupDate + ' ' + this.pickupTime,
        deliveryDate: this.deliveryDate + ' ' + this.deliveryTime
      }
      axios.post('/backend/rest/shipment/' + this.currentShipment.id + '/approve', shipmentApprove)
        .then(response => {
          this.loadShipments(() => {
            this.selectShipmentForCurrentShipment()
            this.approvalStarted = false
          })
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
    },
    send () {
      let shipmentSend = {
        shipmentId: this.currentShipment.id,
        email: this.sendEmail,
        subject: this.sendSubject,
        message: this.sendMessage
      }
      axios.post('/backend/rest/shipment/' + this.currentShipment.id + '/send', shipmentSend)
        .then(response => {
          this.selectShipmentForCurrentShipment()
          this.loadShipments(() => {
            this.sendStarted = false
          })
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
    },
    createInvoice () {
      this.creatingInvoice = true
      axios.post('/backend/rest/shipment/' + this.currentShipment.id + '/create_invoice')
        .then(response => {
          let shipment = response.data
          this.currentShipment.draftInvoiceNumber = shipment.draftInvoiceNumber
          this.$refs.header.showSnackbar('Invoice ' + shipment.draftInvoiceNumber + ' created in e-conomic')
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
        .finally(() => {
          this.creatingInvoice = false
        })
    },
    cancelApprove () {
      this.approvalStarted = false
    },
    cancelSend () {
      this.sendStarted = false
    },
    startLoadingComplete () {
      this.confirmLoadingComplete = true
    },
    loadingComplete () {
      axios.post('/backend/rest/shipment/' + this.currentShipment.id + '/loading_complete')
        .then(response => {
          this.loadShipmentState()
          this.loadPalletOrdersForShipment()
          this.loadPalletsForShipment()
          this.confirmLoadingComplete = false
        })
    },
    cancelLoadingComplete () {
      this.confirmLoadingComplete = false
    },
    openPrintDeliveryNoteDialog () {
      this.printDeliveryNoteWithDetails = false
      this.printDeliveryNoteDialog = true
    },
    printDeliveryNote () {
      // console.log('Print delivery note ' + this.currentShipment.id)
      this.printDeliveryNoteDialog = false
      let url = '/backend/print/deliveryNote.xhtml?shipmentId=' + this.currentShipment.id + '&details=' + this.printDeliveryNoteWithDetails + '&title=Delivery Note'
      setTimeout(function () {
        window.open(url)
      }, 500)
    },
    cancel () {
      // console.log('Cancel the shipment')
      this.currentShipment = null
      this.loadShipments()
    },
    palletTotal (delivery) {
      let total = delivery.numberOfPallets * delivery.piecesPerPallet
      return isNaN(total) ? '0' : Math.round(total)
    },
    otherDeliveryTotal (delivery, field) {
      let total = 0
      if (delivery.category && field) {
        for (let d of this.currentShipment.deliveries) {
          if (d.id !== delivery.id && d.category && d.field && d.category.id === delivery.category.id && d.field.id === field.id) {
            total += this.palletTotal(d)
          }
        }
      }
      // console.log('Other pallet total for delivery ' + delivery.id + ': ' + total)
      return total
    },
    totalNumberOfPallets () {
      let total = 0
      if (this.currentShipment && this.currentShipment.deliveries && this.currentShipment.deliveries.length > 0) {
        for (let delivery of this.currentShipment.deliveries) {
          total += Number(delivery.numberOfPallets)
        }
      }
      let sTotal = total.toFixed(1)
      if (sTotal.endsWith('.0')) {
        sTotal = sTotal.substring(0, sTotal.length - '.0'.length)
      }
      return sTotal
    },
    supplierNames (shipment) {
      if (shipment && shipment.deliveries && shipment.deliveries.length > 0) {
        let supplierNames = []
        for (let delivery of shipment.deliveries) {
          if (delivery.supplier && !supplierNames.includes(delivery.supplier.name)) {
            supplierNames.push(delivery.supplier.name)
          }
        }
        return supplierNames.join('<br/>')
      }
      return ''
    },
    categoryNames (shipment) {
      if (shipment && shipment.deliveries && shipment.deliveries.length > 0) {
        let categoryNames = []
        for (let delivery of shipment.deliveries) {
          if (delivery.category) {
            let nameAndAmount = delivery.category.label + ', ' + (delivery.numberOfPallets * delivery.piecesPerPallet) + 'pcs.'
            if (!categoryNames.includes(nameAndAmount)) {
              categoryNames.push(nameAndAmount)
            }
          }
        }
        return categoryNames.join('<br/>')
      }
      return ''
    },
    palletSelected: function (ctx) {
      // console.log('Pallet selected: ' + JSON.stringify(ctx))
      if (ctx.palletPosition) {
        if (this.currentPalletPosition === ctx.palletPosition) {
          this.currentPalletPosition = null
        } else {
          this.currentPalletPosition = ctx.palletPosition
        }
        this.currentPallet = null
      } else {
        this.currentPallet = ctx.pallet
        this.currentPalletPosition = null
      }
      this.action = null
      if (!this.currentPallet && !this.currentPalletPosition) {
        this.cancelPalletAction()
      }
    },
    prepareUnload: function () {
      this.action = 'UNLOAD'
    },
    unload: function () {
      axios.post('/backend/rest/pallet/unload/' + this.currentPallet.id + '/address/' + this.stockAddress.id)
        .then(response => {
          this.loadShipmentState()
          this.loadPalletOrdersForShipment()
          this.loadPalletsForShipment()
          this.currentPallet = null
          this.action = null
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
    },
    prepareDeliveryComment: function () {
      if (this.currentPallet && this.currentPallet.deliveryComment !== '') {
        this.deliveryComment = this.currentPallet.deliveryComment
      } else {
        this.deliveryComment = ''
      }
      this.action = 'DELIVERY_COMMENT'
    },
    saveDeliveryComment: function () {
      axios.post('/backend/rest/pallet/delivery_comment/' + this.currentPallet.id, this.deliveryComment)
        .then(response => {
          this.loadPalletsForShipment()
          this.currentPallet = null
          this.action = null
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
    },
    prepareCreatePallet: function () {
      this.action = 'CREATE_PALLET'
      this.fieldsNewPallet = [
      ]

      this.newPallet = {
        id: 0,
        uuid: null,
        number: null,
        shipmentNumber: this.currentShipment.number,
        state: 'DELIVERED',
        stateLabel: null,
        supplier: null,
        field: null,
        contractor: null,
        internalCarrier: null,
        location: null,
        position: this.currentPalletPosition,
        half: this.isHalfPalletPosition(this.currentPalletPosition),
        externalNumber: '',
        createdByAdmin: true,
        items: [
          {
            id: 0,
            category: null,
            plannedAmount: 0,
            amount: null
          }
        ]
      }

      this.loadLocationsNewPallet()
    },
    prepareCreateLooseGoods: function () {
      this.action = 'CREATE_LOOSE_GOODS'
      this.fieldsNewPallet = [
      ]

      this.newPallet = {
        id: 0,
        uuid: null,
        number: null,
        shipmentNumber: this.currentShipment.number,
        state: 'DELIVERED',
        stateLabel: null,
        supplier: null,
        field: null,
        contractor: null,
        internalCarrier: null,
        location: null,
        position: 0,
        half: false,
        externalNumber: 'Loose goods',
        createdByAdmin: true,
        items: [
          {
            id: 0,
            category: null,
            plannedAmount: 0,
            amount: null
          }
        ]
      }
      this.showAllCategoriesForNewPallet(this.newPallet.items[0])
    },
    prepareLoadPallet: function () {
      this.loadPalletNumber = ''
      this.palletsByNumber = null
      this.action = 'LOAD'
    },
    prepareLoadLooseGoods: function () {
      this.currentPalletPosition = 0
      this.loadPalletNumber = ''
      this.palletsByNumber = null
      this.action = 'LOAD_LOOSE_GOODS'
    },
    tryLoadPallet: function () {
      this.palletsByNumber = []
      // Check that only one pallet exists
      axios.get('/backend/rest/pallet/summary/for_loading/by_number/' + this.loadPalletNumber)
        .then(response => {
          this.palletsByNumber = response.data

          if (this.palletsByNumber && this.palletsByNumber.length === 0) {
            this.$refs.errorDialog.errorTitle = 'Warning'
            this.$refs.errorDialog.errorMessage = 'Pallet number is not correct'
            this.$refs.errorDialog.errorDialog = true
            this.palletsByNumber = null
          } else if (this.palletsByNumber && this.palletsByNumber.length === 1) {
            this.loadPallet(this.palletsByNumber[0])
          } else {
            // Let the user decide which pallet to load
          }
        })
    },
    loadChosenPallet: function () {
      this.loadPallet(this.chosenPallet)
    },
    loadPallet: function (pallet) {
      axios.post('/backend/rest/pallet/load/' + pallet.id + '/' + this.currentShipment.id + '/' + this.currentPalletPosition)
        .then(response => {
          this.loadShipmentState()
          this.loadPalletOrdersForShipment()
          this.loadPalletsForShipment()
          this.currentPallet = null
          this.currentPalletPosition = null
          this.action = null
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
    },
    cancelPalletAction: function () {
      this.currentPallet = null
      this.currentPalletPosition = null
      this.action = null
    },
    stateLabel: function (state) {
      switch (state) {
        case 'DRAFT': return 'Draft'
        case 'PLANNED': return 'Planned'
        case 'IN_PRODUCTION': return 'In production'
        case 'PRODUCED': return 'Produced'
        case 'READY_FOR_PICKUP': return 'Ready for pickup'
        case 'DELIVERED': return 'Delivered'
      }
      return 'Unknown'
    },
    rowColor: function (shipment) {
      return 'selectable' + (shipment.awaitingApproval ? ' awaitingApproval' : '') + (!this.isShowingDeliveredShipments && shipment.palletsLoaded ? ' palletsLoaded' : '')
    },
    changeSupplierNewPallet () {
      if (this.newPallet.supplier && this.newPallet.supplier.id) {
        this.loadFieldsNewPallet()
      } else {
        this.fieldsNewPallet = []
      }
    },
    loadFieldsNewPallet () {
      let fieldId = this.newPallet && this.newPallet.field ? this.newPallet.field.id : 0
      axios.get('/backend/rest/field/supplier/' + this.newPallet.supplier.id)
        .then(response => {
          this.fieldsNewPallet = response.data
          if (this.fieldsNewPallet && this.fieldsNewPallet.length > 0) {
            if (this.action === 'CREATE_LOOSE_GOODS') {
              this.fieldsNewPallet.splice(0, 0, {
                id: 0,
                address: {
                  nameAndText: ''
                }
              })
            }
            if (fieldId > 0) {
              for (let f of this.fieldsNewPallet) {
                if (f.id === fieldId) {
                  this.newPallet.field = f
                  break
                }
              }
            } else {
              this.newPallet.field = this.fieldsNewPallet[0]
            }
          } else {
            this.newPallet.field = null
          }
        })
    },
    loadLocationsNewPallet () {
      // console.log('Loading locations')
      axios.get('/backend/rest/pickup_address')
        .then(response => {
          // console.log('Pickup addresses: ' + JSON.stringify(response.data))
          this.locationsNewPallet = response.data
          this.locationsNewPallet.splice(0, 0, '')
        })
    },
    updatePlannedAmountNewPallet (item) {
      item.plannedAmount = this.newPallet.half ? item.category.halfPalletAmount : item.category.palletAmount
    },
    changeCategoryNewPallet (item) {
      if (this.action === 'CREATE_PALLET') {
        this.updatePlannedAmountNewPallet(item)
      }
    },
    createNewPallet () {
      // console.log('Create new pallet ' + this.newPallet.number)
      for (let item of this.newPallet.items) {
        delete item.allCategories
      }
      axios.post('/backend/rest/pallet/create_new', this.newPallet)
        .then(response => {
          this.loadShipmentState()
          this.loadPalletOrdersForShipment()
          this.loadPalletsForShipment()
          this.currentPallet = null
          this.currentPalletPosition = null
          this.newPallet = null
          this.action = null
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
    },
    createLooseGoods () {
      // console.log('Create new pallet ' + this.newPallet.number)
      for (let item of this.newPallet.items) {
        delete item.allCategories
      }
      if (this.newPallet.externalNumber.trim() === '') {
        this.newPallet.externalNumber = 'Loose goods'
      }
      axios.post('/backend/rest/pallet/create_new', this.newPallet)
        .then(response => {
          this.loadShipmentState()
          this.loadPalletOrdersForShipment()
          this.loadPalletsForShipment()
          this.currentPallet = null
          this.currentPalletPosition = null
          this.newPallet = null
          this.action = null
        })
        .catch(error => {
          console.log(error.response.data)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = error.response.data.message
          this.$refs.errorDialog.errorDialog = true
        })
    },
    addCategoryNewPallet () {
      let item = {
        id: -this.newPallet.items.length,
        category: null,
        plannedAmount: 0,
        amount: null
      }

      if (this.action === 'CREATE_LOOSE_GOODS') {
        this.showAllCategoriesForNewPallet(item)
      }

      this.newPallet.items.push(item)
    },
    deleteCategoryNewPallet (index) {
      this.newPallet.items.splice(index, 1)
    },
    isHalfPalletPosition (positionNumber) {
      if (this.palletOrderPositions && this.palletOrderPositions.length > 0) {
        return this.palletOrderPositions[positionNumber - 1] && this.palletOrderPositions[positionNumber - 1].half
      }
      return false
    },
    loadCapacities () {
      this.capacities = null
      if (this.currentShipment.customer && this.currentShipment.customer.id !== '' && this.currentShipment.customer.id > 0) {
        axios.get('/backend/rest/shipment/capacity/customer/' + this.currentShipment.customer.id + '/shipment/' + this.currentShipment.id)
          .then(response => {
            this.capacities = response.data
          })
      }
    },
    capacityWarnings () {
      if (this.capacities) {
        if (this.capacities.length === 0) {
          return 'No orders found for this customer'
        }
      }
      return null
    },
    capacityForCategory (category) {
      if (this.capacities && this.capacities[category.id]) {
        let totalPlannedOnShipment = 0
        for (let delivery of this.currentShipment.deliveries) {
          if (delivery.category && delivery.category.id === category.id) {
            totalPlannedOnShipment += this.palletTotal(delivery)
          }
        }
        let capacity = this.capacities[category.id].orderedAmount - this.capacities[category.id].plannedAmount - totalPlannedOnShipment
        return capacity
      }
      return null
    },
    loadLogs () {
      this.logs = []
      axios.get('/backend/rest/log/shipment/' + this.currentShipment.id)
        .then(response => {
          this.logs = response.data
        })
    },
    startViewLog () {
      this.loadLogs()
      this.viewLog = true
    },
    endViewLog () {
      this.viewLog = false
    },
    showAllCategories (delivery) {
      delivery.allCategories = true
      this.deliveryKey++
    },
    showOrderedCategories (delivery) {
      delivery.allCategories = false
      if (delivery.category && delivery.category.id && this.categories.filter(c => c.id === delivery.category.id).length === 0) {
        delivery.category = {}
      }
      this.deliveryKey++
    },
    showAllCategoriesForNewPallet (item) {
      item.allCategories = true
      this.newPalletKey++
    },
    showOrderedCategoriesForNewPallet (item) {
      item.allCategories = false
      if (item.category && item.category.id && this.categories.filter(c => c.id === item.category.id).length === 0) {
        item.category = {}
      }
      this.newPalletKey++
    },
    updateDeliveryAddressOrders () {
      if (this.currentShipment && this.currentShipment.deliveries) {
        let deliveryAddressOrders = this.currentShipment.deliveryAddressOrders
        if (!deliveryAddressOrders) {
          deliveryAddressOrders = []
        }

        // Add new delivery addresses
        let newId = 0
        for (let delivery of this.currentShipment.deliveries) {
          let deliveryAddress = delivery.deliveryAddress
          if (deliveryAddress && deliveryAddress.id > 0) {
            if (deliveryAddressOrders.filter(dao => dao.deliveryAddress.id === deliveryAddress.id).length === 0) {
              let deliveryAddressOrder = {
                id: newId--,
                deliveryAddress: deliveryAddress,
                sortOrder: deliveryAddressOrders.length
              }
              deliveryAddressOrders.push(deliveryAddressOrder)
            }
          }
        }

        // Remove unused delivery addresses
        deliveryAddressOrders = deliveryAddressOrders.filter(dao => this.currentShipment.deliveries.filter(d => d.deliveryAddress && d.deliveryAddress.id === dao.deliveryAddress.id).length > 0)

        // Update the sort order
        if (deliveryAddressOrders) {
          let sortOrder = 0
          for (let dao of deliveryAddressOrders) {
            dao.sortOrder = sortOrder++
          }
        }
        this.currentShipment.deliveryAddressOrders = deliveryAddressOrders
      }
      this.deliveryAddressOrderUpdateKey++
    }
  },
  watch: {
    search (val) {
      this.lastPage = Math.ceil(this.filteredShipments.length / this.shipmentsPerPage)
      if (this.currentPage > this.lastPage) {
        this.currentPage = 1
      }
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
  .deleteButton {
    margin-top: 3px;
    width: 24px;
    height: 24px;
  }
  .deleteButton .v-icon {
    font-size: 18px;
  }
  .palletPosition {
    border-collapse: collapse;
    margin-left: auto;
    margin-right: auto;
  }
  .looseGoods {
    margin-left: 0;
  }
  .palletPosition tr td {
    font-size: 11px;
    width: 20%;
    border: 1px solid rgba(0, 77, 64, 0.6);
    padding: 6px;
    vertical-align: middle;
    text-align: center;
    height: 30px;
  }
  .looseGoods tr td {
    padding: 0 0 5px 0;
    border: 1px solid transparent;
  }
  .palletPosition tr td.selected {
    color: white;
    background-color: rgba(0, 77, 64, 0.8);
  }
  .actions {
    margin-top: 20px;
    margin-bottom: 5px;
    border: 1px solid rgba(0, 77, 64, 0.6);
    border-radius: 4px;
    padding: 8px;
  }
  .actions .actionTitle {
    color: #004d40;
    border-bottom: 1px solid #004d40;
    font-weight: bold;
    padding: 1px;
    margin-bottom: 8px;
  }
  div.categoryFilter {
    padding-bottom: 0 !important;
  }
  table.stockPallets {
    width: 100%;
    border-collapse: collapse;
  }
  table.stockPallets th {
    color: rgba(0, 0, 0, 0.6);
    padding: 0 10px;
  }
  table.stockPallets td {
    padding: 0 10px;
    border-top: 1px solid rgba(0,0,0,.12);
  }
  .approveWithMissingCategories,
  .approveWithPotentialIncorrectDates {
    color: black;
    background-color: #FFDDDD;
    border: 1px solid #FFAAAA;
    border-radius: 3px;
    padding: 5px;
    text-align: center;
    margin-bottom: 15px;
  }
  .deliveryAddressOrder {
    display: inline-flex;
    border: 1px solid gray;
    border-radius: 3px;
    padding: 2px 10px;
    cursor: pointer;
    margin: 0 10px 10px 0;
  }
  table.v-table tbody tr td.singleLine {
    padding-top: 1px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Shipments.vue